import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Col,
} from "reactstrap";

import AddTeamMemberModal from "../../components/modals/AddTeamMemberModal";
import DeleteAlertModal from "../../components/modals/DeleteAlertModal";
// import EditTeamMemberModal from "../../components/modals/EditTeamMemberModal";
import PaginatedItems from "../../components/PaginatedItems";
import { deleteTeam, editAny, fetchAllTeam } from "../../http/http-calls";
import { useSelector } from "react-redux";
import { Oval } from "react-loader-spinner";
import { copyToClipBoard, deepClone, showToast } from "../../helper-methods";
import { convertUrlToCdn } from "../../helper-methods";
const TeamMember = () => {
  const storeData = useSelector((state) => state.userCredential.user);
  let adminId = storeData._id;

  //state
  const [isEmbeddedLoading, setIsEmbeddedLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  // const [isEditOpen, setIsEditOpen] = useState(false);
  const [delModeOpen, setDelModeOpen] = useState(false);
  const [deleteId, setDelId] = useState("");
  const [editDetails, setEditDetails] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [count, setCount] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [payload, setPayload] = useState({
    pageNumber: 1,
    pageSize: 2,
  });

  const [flag, setFlag] = useState(false); // for button disabled after one click

  const _toggle = (isOpen = false) => {
    setIsOpen(isOpen);
    setEditDetails(null);
  };

  // const _toggleEdit = (isEditOpen = false) => {
  //   setIsEditOpen(isEditOpen);
  //   setEditDetails(null);
  // };

  //view all team
  const _fetchTeam = async (pageConfig = payload) => {
    if (pageConfig && pageConfig.isFetchAll) {
      try {
        const res = await fetchAllTeam(pageConfig);
        // console.log("CSV>>", res);
        setTeamMembers(res.data);
        setCount(res.count);
        setItemPerPage(res.data.length);
      } catch (error) {
        // console.log("error", error);
      }
    } else {
      // Only show embedded loader for filtering/pagination, not initial load
      if (!pageConfig?.isInitialLoad && !isInitialLoad) {
        setIsEmbeddedLoading(true);
      }

      try {
        const res = await fetchAllTeam(pageConfig || payload);
        // console.log("allTeam>>", res);
        setTeamMembers(res.data);
        setCount(res.count);
        setItemPerPage(res.data.length);
        if (!pageConfig?.isInitialLoad && !isInitialLoad) {
          setIsEmbeddedLoading(false);
        }
        if (isInitialLoad || pageConfig?.isInitialLoad) setIsInitialLoad(false);
      } catch (error) {
        // console.log("error", error);
        if (!pageConfig?.isInitialLoad && !isInitialLoad) {
          setIsEmbeddedLoading(false);
        }
        if (isInitialLoad || pageConfig?.isInitialLoad) setIsInitialLoad(false);
      }
    }
  }; /* eslint-disable */
  useEffect(() => {
    _fetchTeam({ ...payload, isInitialLoad: true });
  }, []);

  //status change
  const _changeStatus = async (event, id, index) => {
    setFlag(true);
    let oldReports = JSON.parse(JSON.stringify(teamMembers));

    const value = event.target.checked;
    teamMembers[index].isActive = value;
    setTeamMembers([...teamMembers]);

    try {
      const res = await editAny(id, { isActive: value });
      // console.log("resForUpdatingStatus>>", res);
      // _fetchTeam();
      copyToClipBoard("status", event.target.value);
    } catch (error) {
      // console.log(error);
      setTeamMembers(oldReports);
      showToast(error.message, "error");
    }
    setFlag(false);
  };

  //delete member from joined group

  const _removeMemberFromJoinGrouped = async (memberId) => {
    // console.log(memberId);
    _deleteToggle(true, memberId);
  };
  const _deleteToggle = (delModeOpen = false, id) => {
    setDelModeOpen(delModeOpen);
    setDelId(id);
  };

  //delete member api call
  const _deleteMemberHandler = async () => {
    try {
      const res = await deleteTeam(deleteId);
      // console.log("deleteCall",res);
      _fetchTeam();
      showToast(res.reason, "success");
    } catch (error) {
      // console.log("errors",error);
      showToast(error.message, "error");
    }
  };

  //edit

  const _editHandler = (details) => {
    _toggle(true);
    setEditDetails(details);
  };

  // debounce function
  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  //filter and search
  const _statusHandler = async (field, event) => {
    const newSearchData = payload;
    newSearchData[field] = event.target.value;
    // setSearchData(newSearchData);

    if (event.target.value.length) {
      newSearchData[field] = event.target.value;
      setPayload({ ...payload, pageNumber: 1 });
    } else {
      // console.log("field >>", field);
      delete newSearchData[field];
    }
    // setSearchData(newSearchData);
    // console.log("newSearchFilterData >", newSearchData);
    _checkHandler(newSearchData);
  };

  //debouncing function call
  const optimizedFn = useCallback(debounce(_statusHandler));

  //api call for search and filter
  const _checkHandler = async (data) => {
    // console.log("check>>",data)
    await _fetchTeam(data);
  };
  //pagination
  const handlePageClick = (pageNumber) => {
    // console.log(pageNumber);
    let newPageConfig = deepClone(payload);
    newPageConfig["pageNumber"] = pageNumber + 1;
    setPayload(newPageConfig);
    _fetchTeam(newPageConfig);
  };

  return (
    <>
      <div className="innerHeader">
        {/* page title */}
        <h2>Team</h2>
        {storeData.isSuperAdmin ? (
          <div className="right">
            <Button onClick={() => _toggle(true)} color="primary">
              Create New
            </Button>
          </div>
        ) : null}
      </div>
      {/* filter */}
      <div className="filterWrapper">
        <div className="filterIcon">
          <i className="fas fa-filter"></i>
        </div>

        <div className="filterForm">
          <div className="formGroup">
            <Label>Status</Label>
            <Input
              type="select"
              onChange={(event) => optimizedFn("status", event)}
            >
              <option value="">All</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Input>
          </div>

          {/* search */}
          <div className="formGroup searchbar">
            <Label>Search</Label>
            <InputGroup>
              <Input
                placeholder="Search..."
                onChange={(event) => optimizedFn("searchText", event)}
              />
              <InputGroupText>
                <i className="fas fa-search"></i>
              </InputGroupText>
            </InputGroup>
          </div>
        </div>
      </div>
      <React.Fragment>
        <div className="bg-white p-2 mt-4" style={{ borderRadius: 8 }}>
          {isEmbeddedLoading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "40px 0",
                minHeight: "200px",
                alignItems: "center",
              }}
            >
              <Oval color="#3498DB" />
            </div>
          ) : (
            <div className="userList">
              <Row className="text-center">
                {teamMembers.map((member, index) => (
                  <Col xl="3" lg="4" md="6" sm="12" key={index}>
                    <div className="user_box">
                      <div className="user_image">
                        <img
                          src={
                            member.displaypictureurl
                              ? convertUrlToCdn(member.displaypictureurl)
                              : require("../../assets/img/default-profile.svg")
                                  .default
                          }
                          alt="avatar"
                        />

                        <div className="switch_box">
                          <FormGroup switch>
                            {!member.isSuperAdmin &&
                            storeData.email !== member.email ? (
                              <Input
                                type="checkbox"
                                onChange={(event) =>
                                  _changeStatus(event, member._id, index)
                                }
                                checked={member.isActive}
                                disabled={flag === true}
                              />
                            ) : (
                              <Input
                                type="checkbox"
                                onChange={(event) =>
                                  _changeStatus(event, member._id, index)
                                }
                                checked={member.isActive}
                                disabled
                              />
                            )}
                          </FormGroup>
                        </div>
                      </div>
                      <div className="user_content">
                        <h1 className="text-capitalize">
                          {member.lastname
                            ? member.firstname + " " + member.lastname
                            : member.firstname}
                          <span>
                            <i
                              title="Update Member"
                              // onClick={() => _toggleEdit(true)}
                              className="fas fa-pencil-alt edit ml-1"
                              onClick={() => _editHandler(member)}
                            />
                            {member.isSuperAdmin || adminId === member._id ? (
                              <i
                                title="Remove Member"
                                className="far fa-trash-alt detele ml-1"
                                onClick={(event) => event.preventDefault()}
                              />
                            ) : (
                              <i
                                title="Remove Member"
                                className="far fa-trash-alt detele ml-1"
                                onClick={() =>
                                  _removeMemberFromJoinGrouped(member._id)
                                }
                              />
                            )}
                          </span>
                        </h1>
                        <ul>
                          <li>
                            <i className="fa fa-phone me-1" />
                            {member.phone}
                          </li>
                          <li>
                            <i className="fa fa-envelope me-1" />
                            {member.email}
                          </li>

                          <li>
                            <i className="fa fa-map-marker me-1" />
                            {member.location}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          )}
        </div>
      </React.Fragment>

      <AddTeamMemberModal
        isOpen={isOpen}
        toggle={() => _toggle()}
        fetchTeamMember={_fetchTeam}
        isEdit={editDetails === null ? false : true}
        editDetails={editDetails}
      />
      {/* <EditTeamMemberModal 
        isOpen={isEditOpen} 
        toggle={() => _toggleEdit()} 
      /> */}
      <DeleteAlertModal
        delModeOpen={delModeOpen}
        deleteTeamMember={() => _deleteMemberHandler()}
        toggle={() => _deleteToggle()}
      />
      <PaginatedItems
        itemsPerPages={itemPerPage}
        totalCount={count}
        selectedPage={payload.pageNumber}
        itemsPerPage={payload.pageSize}
        onPageChange={handlePageClick}
      />
    </>
  );
};

export default TeamMember;
